import { token } from "functions/Helper";
import EnqueuedList from "views/YuuClawback/EnqueuedList";
import FailedList from "views/YuuClawback/FailedList";
import ProcessedList from "views/YuuClawback/ProcessedList";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import ViewYuuClawback from "views/YuuClawback/ViewYuuClawback";
import CreateYuuClawback from "views/YuuClawback/Create";
import Retry from "views/YuuClawback/Retry";

const yuuClawback = () => {
  let views = [];

  if (token["yuu.clawbacks.read"] === "allowed" || token.is_admin === "True") {
    views = views.concat([
      {
        path: "/YuuClawback/Enqueued",
        name: "Enqueued",
        mini: "EN",
        component: EnqueuedList,
        layout: "/admin"
      },
      {
        path: "/YuuClawback/Processed",
        name: "Processed",
        mini: "PR",
        component: ProcessedList,
        layout: "/admin"
      },
      {
        path: "/YuuClawback/Failed",
        name: "Failed",
        mini: "FA",
        component: FailedList,
        layout: "/admin"
      }
    ]);
  }

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Yuu Clawbck",
        icon: MonetizationOnIcon,
        state: "YuuClawback",
        views: views
      }
    ];
  return [];
};

const yuuClawbackHidden = () => {
  let views = [];

  if (token["yuu.clawbacks.read"] === "allowed" || token.is_admin === "True") {
    views.push({
      path: "/YuuClawback/Detail",
      name: "View Yuu Clawback",
      component: ViewYuuClawback,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  if (token["yuu.clawbacks.write"] === "allowed" || token.is_admin === "True") {
    views = views.concat([
      {
        path: "/YuuClawback/Create",
        name: "Create Yuu Clawback",
        component: CreateYuuClawback,
        layout: "/admin"
      },
      {
        path: "/YuuClawback/Retry",
        name: "Retry Yuu Clawback",
        component: Retry,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      }
    ]);
  }

  return [
    {
      collapse: true,
      name: "Yuu Clawback Hidden",
      state: "YuuClawbackHidden",
      hideInSidebar: true,
      views: views
    }
  ];
};

export { yuuClawback, yuuClawbackHidden };
